import React, { createContext, useContext, useState, useCallback } from "react";
import {
  getAsignaturas,
  createAsignatura,
  updateAsignatura,
  deleteAsignatura,
  getAsignaturasConSalones,
  asignarAsignaturaSalon,
  actualizarIHAsignaturaSalon,
  eliminarAsignaturaSalon,
  asignarMasivamente
} from "../services/asignaturaService";

const AsignaturasContext = createContext();

export const useAsignaturas = () => useContext(AsignaturasContext);

export const AsignaturasProvider = ({ children }) => {
  const [asignaturas, setAsignaturas] = useState([]);
  const [asignaturasConSalones, setAsignaturasConSalones] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAsignaturas = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAsignaturas();
      setAsignaturas(data);
    } catch (error) {
      console.error("Error cargando asignaturas:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAsignaturasConSalones = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAsignaturasConSalones();
      setAsignaturasConSalones(data);
    } catch (error) {
      console.error("Error cargando asignaturas con salones:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const crearAsignatura = async (data) => {
    setLoading(true);
    try {
      await createAsignatura(data);
      await fetchAsignaturas();
    } finally {
      setLoading(false);
    }
  };

  const editarAsignatura = async (id, data) => {
    setLoading(true);
    try {
      await updateAsignatura(id, data);
      await fetchAsignaturas();
    } finally {
      setLoading(false);
    }
  };

  const eliminarAsignaturaData = async (id) => {
    setLoading(true);
    try {
      await deleteAsignatura(id);
      await fetchAsignaturas();
    } finally {
      setLoading(false);
    }
  };

  const asignarASalon = async (data) => {
    setLoading(true);
    try {
      await asignarAsignaturaSalon(data);
      await fetchAsignaturasConSalones();
    } finally {
      setLoading(false);
    }
  };

  const asignarMasivo = async (asignaciones) => {
    setLoading(true);
    try {
        const resultado = await asignarMasivamente(asignaciones);
        await fetchAsignaturasConSalones();
        return resultado;
    } catch (error) {
        console.error("Error en asignación masiva:", error);
        throw error;
    } finally {
        setLoading(false);
    }
    };

  const actualizarIH = async (asignaturaSalonId, IH) => {
    setLoading(true);
    try {
      await actualizarIHAsignaturaSalon(asignaturaSalonId, IH);
      await fetchAsignaturasConSalones();
    } finally {
      setLoading(false);
    }
  };

  const eliminarAsignacion = async (asignaturaSalonId) => {
    setLoading(true);
    try {
      await eliminarAsignaturaSalon(asignaturaSalonId);
      await fetchAsignaturasConSalones();
    } finally {
      setLoading(false);
    }
  };

  return (
    <AsignaturasContext.Provider
      value={{
        asignaturas,
        asignaturasConSalones,
        loading,
        fetchAsignaturas,
        fetchAsignaturasConSalones,
        crearAsignatura,
        editarAsignatura,
        eliminarAsignaturaData,
        asignarASalon,
        actualizarIH,
        eliminarAsignacion,
        asignarMasivo
      }}
    >
      {children}
    </AsignaturasContext.Provider>
  );
};